import type { ParentComponent, VoidComponent } from "solid-js";
import type { IconName } from "../../icon/Icon";
import Handlebar from "../Handlebar";
import type { Category } from "../../../types";
import { getIconCategoryColor } from "../../../utils/iconColorUtil";
import { DynamicValueIconTile, IconTile } from "../../icon/IconTile";

export type DraggableOverlayProps = {
  label: string;
  icon: IconName;
  category: Category;
};

const OverlayContainer: ParentComponent = (props) => (
  <div class="relative flex w-lg cursor-grabbing items-center gap-2 rounded-sm border border-default bg-surface-default py-4 pr-6 pl-2 text-left text-base-medium text-primary shadow-elevation-light-3">
    {props.children}
  </div>
);

const FieldDragOverlay: VoidComponent<DraggableOverlayProps> = (props) => (
  <OverlayContainer>
    <Handlebar />
    <DynamicValueIconTile
      icon={props.icon}
      iconClassList={{ [getIconCategoryColor(props.category)]: true }}
      size="md"
    />
    <span class="w-full truncate">{props.label}</span>
  </OverlayContainer>
);

export default FieldDragOverlay;

export type IntegrationPropertyContainerOverlayProps = {
  label: string;
  icon: IconName;
};
const IntegrationPropertyContainerOverlay: VoidComponent<IntegrationPropertyContainerOverlayProps> = (props) => (
  <OverlayContainer>
    <Handlebar />
    <IconTile icon={props.icon} size="md" border />
    <span class="w-full truncate">{props.label}</span>
  </OverlayContainer>
);

export { IntegrationPropertyContainerOverlay };
